const PROTOCOL = process.env.FEED_PROTOCOL || 'https';

export default {
  port: parseInt(process.env.PORT, 10) || 3000,

  redisEndpoint: 'localhost',

  privateRepo: {
    registry: `${PROTOCOL}://next.managewnow.manageddev1.worldnow.com:5005/`,
    username: 'frankly',
    password: 'frankly',
    email: 'frankly@franklyinc.com',
    defaultPackage: 'wnow'
  },

  // Set this to simulate specific affiliate site. This is usually used locally
  // in a development environment. e.g., kdrv.web.franklyinc.com
  //
  defaultConfigHost: '0.0.0.0',

  apiEndpoint: process.env.API_ENDPOINT || 'https://platform-qa.franklyinc.com',
  widgetApiEndpoint: process.env.WIDGET_API_ENDPOINT || 'https://api.ddev1.worldnow.com/feed/v3.0/widgets',

  // AMS endpoint.
  //
  // amsEndpoint: {
  //   url: 'https://parse.franklyinc.com/classes/AppConfig',
  //   headers: {
  //     'X-Parse-Application-Id': 'wPJuyJsloZ14Rx7rUIk1BLLlpmrVt7rHqD5w3iza'
  //   }
  // }
};



// WEBPACK FOOTER //
// ./server/config/development.js